// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SummarizeDocumentMutationVariables = Types.Exact<{
  input: Types.SummarizeDocumentInput;
}>;


export type SummarizeDocumentMutation = { __typename?: 'Mutation', summarizeDocument: boolean };

export type RegenerateSummaryModalFormDataQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  documentType: Types.DocumentType;
  documentSummaryPromptDocumentTypes: Array<Types.DocumentSummaryPromptDocumentType> | Types.DocumentSummaryPromptDocumentType;
}>;


export type RegenerateSummaryModalFormDataQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string, summaries?: Array<(
          { __typename?: 'DocumentSummary', id: string }
          & RegenerateSummaryModal_DocumentSummaryFragment
        )> | null } | null } | null> | null }, documentSummaryPrompts: { __typename?: 'DocumentSummaryPromptConnection', edges?: Array<{ __typename?: 'DocumentSummaryPromptEdge', node?: { __typename?: 'DocumentSummaryPrompt', id: string, displayName: string, shouldAutoRun: boolean, isDefaultForDocType: boolean } | null } | null> | null } };

export type RegenerateSummaryModal_DocumentSummaryFragment = { __typename?: 'DocumentSummary', id: string, displayName: string };

export const Operations = {
  Query: {
    RegenerateSummaryModalFormData: 'RegenerateSummaryModalFormData' as const
  },
  Mutation: {
    SummarizeDocument: 'SummarizeDocument' as const
  },
  Fragment: {
    RegenerateSummaryModal_DocumentSummary: 'RegenerateSummaryModal_DocumentSummary' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const RegenerateSummaryModal_DocumentSummaryFragmentDoc = gql`
    fragment RegenerateSummaryModal_DocumentSummary on DocumentSummary {
  id
  displayName
}
    `;
export const SummarizeDocumentDocument = gql`
    mutation SummarizeDocument($input: SummarizeDocumentInput!) {
  summarizeDocument(input: $input)
}
    `;
export type SummarizeDocumentMutationFn = Apollo.MutationFunction<SummarizeDocumentMutation, SummarizeDocumentMutationVariables>;

/**
 * __useSummarizeDocumentMutation__
 *
 * To run a mutation, you first call `useSummarizeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSummarizeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [summarizeDocumentMutation, { data, loading, error }] = useSummarizeDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSummarizeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SummarizeDocumentMutation, SummarizeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SummarizeDocumentMutation, SummarizeDocumentMutationVariables>(SummarizeDocumentDocument, options);
      }
export type SummarizeDocumentMutationHookResult = ReturnType<typeof useSummarizeDocumentMutation>;
export type SummarizeDocumentMutationResult = Apollo.MutationResult<SummarizeDocumentMutation>;
export type SummarizeDocumentMutationOptions = Apollo.BaseMutationOptions<SummarizeDocumentMutation, SummarizeDocumentMutationVariables>;
export const RegenerateSummaryModalFormDataDocument = gql`
    query RegenerateSummaryModalFormData($householdId: ID!, $documentType: DocumentType!, $documentSummaryPromptDocumentTypes: [DocumentSummaryPromptDocumentType!]!) {
  documents(
    where: {hasSummaries: true, hasHouseholdWith: {id: $householdId}, type: $documentType}
  ) {
    edges {
      node {
        id
        name
        summaries {
          id
          ...RegenerateSummaryModal_DocumentSummary
        }
      }
    }
  }
  documentSummaryPrompts(
    where: {documentTypeIn: $documentSummaryPromptDocumentTypes}
  ) {
    edges {
      node {
        id
        displayName
        shouldAutoRun
        isDefaultForDocType
      }
    }
  }
}
    ${RegenerateSummaryModal_DocumentSummaryFragmentDoc}`;

/**
 * __useRegenerateSummaryModalFormDataQuery__
 *
 * To run a query within a React component, call `useRegenerateSummaryModalFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegenerateSummaryModalFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegenerateSummaryModalFormDataQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      documentType: // value for 'documentType'
 *      documentSummaryPromptDocumentTypes: // value for 'documentSummaryPromptDocumentTypes'
 *   },
 * });
 */
export function useRegenerateSummaryModalFormDataQuery(baseOptions: Apollo.QueryHookOptions<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>(RegenerateSummaryModalFormDataDocument, withFetchPolicyContext(options));
      }
export function useRegenerateSummaryModalFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>(RegenerateSummaryModalFormDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useRegenerateSummaryModalFormDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>(RegenerateSummaryModalFormDataDocument, withFetchPolicyContext(options));
        }
export type RegenerateSummaryModalFormDataQueryHookResult = ReturnType<typeof useRegenerateSummaryModalFormDataQuery>;
export type RegenerateSummaryModalFormDataLazyQueryHookResult = ReturnType<typeof useRegenerateSummaryModalFormDataLazyQuery>;
export type RegenerateSummaryModalFormDataSuspenseQueryHookResult = ReturnType<typeof useRegenerateSummaryModalFormDataSuspenseQuery>;
export type RegenerateSummaryModalFormDataQueryResult = Apollo.QueryResult<RegenerateSummaryModalFormDataQuery, RegenerateSummaryModalFormDataQueryVariables>;